const OAUTH_STATE_KEY = "employee_interview_oauth_state";
const STATE_EXPIRATION_MS = 10 * 60 * 1000;

type OAuthPurpose = "calendar_link" | "additional_account";

interface OAuthStatePayload {
  nonce: string;
  purpose: OAuthPurpose;
  ts: number;
}

export function generateOAuthState(purpose: OAuthPurpose): string {
  const payload: OAuthStatePayload = {
    nonce: crypto.randomUUID(),
    purpose,
    ts: Date.now(),
  };
  const state = btoa(JSON.stringify(payload));
  sessionStorage.setItem(OAUTH_STATE_KEY, state);
  return state;
}

export function validateOAuthState(receivedState: string): {
  purpose: OAuthPurpose;
  nonce: string;
} {
  const storedState = sessionStorage.getItem(OAUTH_STATE_KEY);
  sessionStorage.removeItem(OAUTH_STATE_KEY);

  if (!storedState || storedState !== receivedState) {
    throw new Error("CSRF検証に失敗しました。もう一度ログインしてください。");
  }

  const payload = JSON.parse(atob(receivedState)) as OAuthStatePayload;

  if (Date.now() - payload.ts > STATE_EXPIRATION_MS) {
    throw new Error(
      "認証の有効期限が切れました。もう一度ログインしてください。",
    );
  }

  return { purpose: payload.purpose, nonce: payload.nonce };
}

export function clearOAuthState(): void {
  sessionStorage.removeItem(OAUTH_STATE_KEY);
}
